import React from "react";
import * as yup from "yup";

const validationSchema = yup.object({
  requestName: yup.string().required("request name is required"),
  database_type: yup.number().required("database table is required"),
  dbOperationType: yup.string().required("database operation type is required"),
  noOfColumnsRequired: yup
    .number()
    .when("dbOperationType", {
      is: "delete",
      then: yup.number().min(1, "can not be less than 1"),
    })
    .min(2, "must be greater than 1")
    .max(50, "can not be greater than 50")
    .required("Enter columns required"),
  // columnsRequired: yup.array("Array").min(2, "minimum of 2 columns required"),
  database_table: yup.string().required("database table is required"),
  database_name: yup.string().required("database name is required"),
  zonalApproval: yup.boolean().required(),
  shpHeadApproval: yup.boolean().required(),
  executionMethod: yup.string().required("execution method is required"),
  requestTypeDescription: yup.string().required("describe request type "),
});
export default validationSchema;
